import { select } from "@angular-redux/store";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { PlanningBlock } from "../../../models/planning-block/planning-block.interface";
import { PbActions } from "../../../pb.actions";
import { PbScreenService } from "../../../services/pb-screen.service";
import { SharedActions } from "../../../../shared/shared.actions";
import { UserFeedbackService } from "../../../../services/user-feedback.service";
import { inherits } from "util";
import { SimpleModalComponent } from "ngx-simple-modal";


@Component({
  moduleId: module.id,
  selector: "unplan-modal",
  templateUrl: "./unplan-modal.component.html",
})

export class UnplanModalComponent_old extends SimpleModalComponent<UnplanModelInput, boolean> implements OnInit, UnplanModelInput {
  @Input() public source: string;
  @ViewChild("modal") public modal: ElementRef;
  @select("selectedPlanningBlocks") public selectedPlanningBlocks$: Observable<PlanningBlock[]>;
  @select("loading") public loading$: Observable<boolean>;

  public selectedPlanningBlocks: PlanningBlock[] = [];
  public loadingSpinner: boolean = false;

  constructor(
    public readonly pbScreenService: PbScreenService,
    public readonly pbActions: PbActions,
    public readonly translate: TranslateService,
    public readonly userFeedbackService: UserFeedbackService,
    public readonly sharedActions: SharedActions,
  ) {
    super();
  }

  public ngOnInit(): void {
    this.loading$.subscribe((data) => {
      if (!data) {
        this.loadingSpinner = data;
      }
    });
    if (!this.selectedPlanningBlocks) {
      this.selectedPlanningBlocks$.subscribe((pbs: PlanningBlock[]) => {
        this.selectedPlanningBlocks = pbs;
      });
    }
  }

  public unplanAction(cancelSendToHaulier: boolean): void {
    this.loadingSpinner = true;

    this.pbScreenService.unplanPlanningBlocks(this.selectedPlanningBlocks, cancelSendToHaulier).subscribe((unplannedPbs: PlanningBlock[]) => {
      this.loadingSpinner = false;

      this.sharedActions.updatePlanningBlocksDisplay(unplannedPbs);
      this.translate.get("TOASTR_MESSAGES.SUCCESS.UNPLAN_SUCCEEDED").subscribe((res: string) => {
        this.userFeedbackService.showSuccessMessageWithoutTranslating(res);
        this.closeModalAction(true);
      });
    }, _ => {
      this.loadingSpinner = false;
    });
  }

  public closeModalAction(cofirmAction: boolean): void {
    this.modal.nativeElement.click();
    this.result = cofirmAction;
    this.close();
  }
}

export interface UnplanModelInput {
  source: string;
  selectedPlanningBlocks: PlanningBlock[];
}
